export default "__VITE_ASSET__a5TOrwtb__"